import React from 'react'
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import PDFViewer from '../Elements/PDFViewer';
import './Styling/Account.css';





const Account = () => {
    const { user, logout, isAuthenticated, isLoading } = useAuth0();
    const [view, setView] = React.useState('manual');
    const [refreshList, setRefreshList] = React.useState([<div></div>]);
    const [manual, setManual] = React.useState(null);
    const [hasLoadedOnce, setHasLoadedOnce] = React.useState(false);  // Add this
    const [formData, setFormData] = React.useState({
        name: '',
        emzail: '',
        msgType: 'query',
        message: ''
    });
    const navigate = useNavigate();

    const serverName="https://api.myemployeemanual.com";
    async function handleLogin(){       
        const addUser=await fetch(`${serverName}/addUser?userID=${user.sub}&email=${user.email}`, {
            method: 'POST',
        });
        const data=await addUser.json();
        console.log(data);
    }

    async function purchase(){
        const stripePromise = loadStripe('pk_live_51R8rrxDhOA29IJXcsTMwDBuzj8crNuQwUvJwKpkNmSuGPrLKOqjxGGowete9qMryKbxatuOkUhRIRe3xHA350x5600CRHgi0Jv');
        const stripe=await stripePromise;
        const startSession=await fetch(`${serverName}/createSession?userID=${user.sub}&price=price_1R9ExaDhOA29IJXcscZS4wao&qty=1`,{
            method: 'POST',
        });
        const sessionID=await startSession.json();
        const result = await stripe.redirectToCheckout({
            sessionId: sessionID["sessionId"],
        });
    }

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        console.log(formData);
    };

    async function handleTermination(){

    }

    React.useEffect(() => {
        if(isAuthenticated && !isLoading){
            setHasLoadedOnce(true);
            handleLogin();
            getManual();
            getRefreshes();
        } else if (!isAuthenticated && !isLoading) {
            setHasLoadedOnce(false);  // Reset on logout
        }
    },[isAuthenticated, isLoading]);

    React.useEffect(() => {
        // Only redirect if not loading, not authenticated, and has been authenticated before
        if (!isLoading && !isAuthenticated && hasLoadedOnce) {
            setHasLoadedOnce(false);  // Reset before redirecting
            navigate('/');
        }
    }, [isLoading, isAuthenticated, hasLoadedOnce, navigate]);

    async function getManual(){
        try {
            const getManualResponse = await fetch(`${serverName}/returnManual?userID=${user.sub}`, {
                method: 'GET',
            });
            const data = await getManualResponse.json();
            console.log("manual data:", data);
            console.log("hasManual:", data['hasManual']);
            console.log("manual length:", data['manual']?.length);
            
            if (!data['hasManual'] || !data['manual']) {
                console.log("No manual found");
                setManual(null);
            } else {
                // Convert base64 to data URL for react-pdf
                const pdfDataUrl = `data:application/pdf;base64,${data['manual']}`;
                console.log("PDF data URL created, length:", pdfDataUrl.length);
                setManual(pdfDataUrl);
                console.log("manual",manual)
            }
        } catch (error) {
            console.error("Error fetching manual:", error);
            setManual(null);
        }
    }

    async function getRefreshes(){
        try{
            const getRefreshes=await fetch(`${serverName}/returnRefreshes?userID=${user.sub}`, {
                method: 'GET',
            });
            const data=await getRefreshes.json();
            const refreshes=[];
            if (data.length===0){
                setRefreshList(
                    <div className='noRefreshes'>
                        <h2>No Manuals Found</h2>
                    </div>
                )
            }else{
                for(let i=0; i<data.length; i++){
                    refreshes.push(<div className='refreshManual'>
                        <h2>{data['date'][i]}</h2>
                        <h2 className='right'>{data['refreshes'][i]}</h2>
                    </div>)
                }
                setRefreshList(<div className='refreshes'>
                    {refreshes}
                </div>);
            }
        }catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    async function sendSupport(name, email, msgType, message){
        console.log(message);
        const sendSupport=await fetch(`${serverName}/sendSupport?userID=${user.name}&name=${name}&email=${email}&msgType=${msgType}&message=${message}`, {
            method: 'POST',
        });
        console.log(sendSupport.json());
    }
    
    function getAccBody(){
        if(view==='manual'){
            return(
                <div className='manualView'>
                    <PDFViewer pdf={manual}/>
                </div>
            )
        }
        if(view==='refreshes'){
            return(
                <div className='refreshesView'>
                    <Link to='/account/refresh' className='refreshButton'>Get an Updated Manual</Link>
                    {refreshList}
                </div>
            )
        }
        if(view==='updateReq'){
            return(
                <div className='updateReqView'>

                </div>
            )
        }
        if(view==='settings'){
            return(
                <div className='settings'>
                    <h2>Username: {user.name}</h2>
                    <h2>Email: {user.email}</h2>
                    <h2>Account Created: {user.created_at}</h2>
                    <h2>Account ID: {user.sub}</h2>
                    <button className='terminateAccount' onClick={handleTermination}>Terminate Account</button>
                </div>
            )
        }
        if(view==='support'){
            return(
                <div className='support'>
                    <form className='supportForm'>
                        <div className='inElem'>
                            <label htmlFor='name'>Name:</label>
                            <input type='text' id='name' name='name' onChange={handleInputChange} required/>
                        </div>
                        <br />
                        <div className='inElem'>
                            <label htmlFor='email'>Email:</label>
                            <input type='email' id='email' name='email' placeholder={user.email} onChange={handleInputChange} required/>
                        </div>
                        <br />
                        <div className='inElem'>
                            <label htmlFor='msgType'>Message Type:</label>
                            <select id='msgType' name='msgType' onChange={handleInputChange} required>
                                <option value='query'>Question</option>
                                <option value='feedback'>Feedback</option>
                                <option value='bug'>Bug</option>
                                <option value='other'>Other</option>
                            </select>
                        </div>
                        <br />
                        <div className='inElem'>
                            <label htmlFor='message'>Message:</label>
                            <textarea id='message' name='message' onChange={handleInputChange} required></textarea>
                        </div>
                        <button className='submitButton' type='submit' onClick={() => sendSupport(formData['name'], formData['email'], formData['msgType'], formData['message'])}>Submit</button>
                    </form>
                </div>
            )
        }
    }

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (!isAuthenticated) {
        return null; 
    }
    return (
            <div className='account'>
                <h1>Welcome {user.name},</h1>
                <div className='accountBody'>
                    <div className='accNav'>
                        <div className='navHalf'>
                            <button onClick={()=>setView('manual')}>Manual</button>
                        </div>
                        <div className='navHalf'>
                            <button onClick={()=>setView('settings')}>Settings</button>
                            <button onClick={()=>setView('support')}>Support</button>
                            <button onClick={logout}>Logout</button>
                        </div>
                    </div>
                    <div className='accBody'>
                        {getAccBody()}
                    </div>
                </div>
            </div>
    );
    }

export default Account;

//                            <button onClick={()=>setView('refreshes')}>Refreshes</button>